// extracted by mini-css-extract-plugin
export default {"checkIcon":"ProgressRing_checkIcon__Gx3nF"};